import React from 'react';
import { motion } from 'framer-motion';
import { Users, Clock, MapPin } from 'lucide-react';

export function RegistrationCounter({ className, totalRegistered, maxCapacity, eventDate, eventLocation, theme_active, theme_bg_gradiemt, theme_btn_bg, theme_btn_text }) {
  const percentageFilled = (totalRegistered / maxCapacity) * 100;

  return (
    <div className={`bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 h-full ${className}`}>
      <div className="space-y-8">
        {/* Registration Progress */}
        <div>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Users className={`w-5 h-5 text-amber-400 ${theme_active}`} />
              <h3 className="text-lg font-medium">Registration Progress</h3>
            </div>
            <span className="text-sm text-gray-400">{percentageFilled.toFixed(1)}% Full</span>
          </div>
          
          <div className="relative h-4 bg-white/5 rounded-full overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${percentageFilled}%` }}
              transition={{ duration: 1, delay: 0.5 }}
              className={`absolute h-full bg-gradient-to-r from-amber-500 to-amber-600 rounded-full ${theme_bg_gradiemt}`}
            />
          </div>
          
          <div className="flex justify-between mt-2 text-sm">
            <span className={`text-amber-400 ${theme_active}`}>{totalRegistered} Registered</span>
            <span className="text-gray-400">{maxCapacity} Capacity</span>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white/5 rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <Clock className={`w-4 h-4 text-amber-400 ${theme_active}`} />
              <span className="text-sm text-gray-400">Event Date</span>
            </div>
            <p className="text-lg">{eventDate}</p>
          </div>
          
          <div className="bg-white/5 rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <MapPin className={`w-4 h-4 text-amber-400 ${theme_active}`} />
              <span className="text-sm text-gray-400">Location</span>
            </div>
            <p className="text-lg">{eventLocation}</p>
          </div>
        </div>

        {/* Spots Remaining */}
        <div className="text-center">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="inline-block"
          >
            <div className={`bg-amber-500/10 rounded-full px-6 py-3 ${theme_btn_bg}`}>
              <p className={`text-2xl font-bold text-amber-400 ${theme_btn_text}`}>
                {maxCapacity - totalRegistered} Spots Remaining
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}